import { render, staticRenderFns } from "./SafetProfile.vue?vue&type=template&id=14f1d161&"
import script from "./SafetProfile.vue?vue&type=script&lang=js&"
export * from "./SafetProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports